import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils";

const saveDoctorApi = async (params) => {
  const response = await axios({
    // url: `${config.api.base_url}doctor`,
    url: `${config.api.base_url}doctor/sign-up-request`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getDoctorToken()}`,
    },
  });

  return response;
};

export default saveDoctorApi;
